import MuiGrid from '@material-ui/core/Grid'
import Hidden from '@material-ui/core/Hidden'
import React from 'react'

/**
 * @typedef {{ offset?: number | null; }} OffsetProps
 *
 * @typedef {import('@material-ui/core/Grid').GridProps} MuiGridProps
 *
 * @typedef {Pick<MuiGridProps, 'className' | 'children' | 'style' | 'xs' | 'sm' | 'md' | 'lg' | 'xl'> & OffsetProps} GridProps
 *
 * @typedef {GridProps & {
 *   hidden?: boolean;
 * }} CellProps
 */

/**
 * @param {OffsetProps} props
 */
const Offset = ({ offset = null }) => {
  if (!offset) return null

  return (
    <Hidden
      // Conditions for ignoring offset
      smDown={offset >= 8}
    >
      <MuiGrid
        xs={offset}
        item
      />
    </Hidden>
  )
}

const DEFAULT_COLUMNS = 12

/**
 * @param {GridProps} props
 */
const Grid = ({
  className,
  children,
  style,
  xs = DEFAULT_COLUMNS,
  sm,
  md,
  lg,
  xl,
  offset,
}) => {
  return (
    <>
      <Offset offset={offset} />
      <MuiGrid
        item
        className={className}
        style={style}
        xs={xs}
        sm={sm}
        md={md}
        lg={lg}
        xl={xl}
      >
        {children}
      </MuiGrid>
    </>
  )
}

/**
 * ```
 * import { Cell } from '@pickupp/ui/core'
 * ```
 *
 * https://material-ui.com/api/grid/
 *
 * @param {CellProps} props
 */
const Cell = ({
  hidden = false,
  ...gridProps
}) => {
  if (!hidden) {
    return (
      <Grid {...gridProps} />
    )
  }

  return (
    <Hidden only={hidden}>
      <Grid {...gridProps} />
    </Hidden>
  )
}

export default Cell
